Ext.define('SA.view.color.Swatch', {
    alias: 'widget.color-swatch',
    extend: 'Ext.Component',

    cls: 'x-unselectable',
    maxHeight: 15,
    swatchType: 'old',

    initComponent() {
        var swatchType = this.swatchType,
            label, position;

        if (swatchType === 'old') {
            label = 'Old';
            position = 'bottom';
        }
        else if (swatchType === 'new') {
            label = 'New';
            position = 'top';
        }


                this.html = '<span class="x-form-item-label sa-color-window-swatch-label">' + label + '</span>' +
            '<span class="sa-color-window-swatch sa-color-window-swatch-' + position + '"></span>';

        this.callParent();
    },

    getColor() {
        return this.color;
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onClick, this);
    },

    onClick() {
        this.fireEvent('click', this);
    },

    setColor(color) {
        this.color = color;

        this.el.down('.sa-color-window-swatch').setStyle('background-color', '#' + color.getColor());
    }
});